import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
// Styles
import styles from './styles';

import { rateService } from './service';
import { useLocation } from "react-router-dom";

import { TextField, Button } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';

const RateService = props => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  let query = useQuery();
  const { classes } = props;
  const [rate, setRate] = useState({ token: query.get("token"), rating_value: 0, rating_comment: '' });
  const [resultMessage, setResultMessage] = useState({
    isVisible: false,
    title: '',
    message: '',
  });

  const submitRate = async () => {
    const response = await rateService(rate);
    if (response.status === 404) {
      setResultMessage({isVisible: true,
        title: 'Token invalido',
        message: 'La evaluación no se puede registrar. El token no es valido o ya fue evaluado.'});
    } else {
      setResultMessage({isVisible: true,
        title: 'Evalución completeda',
        message: 'Enviado satisfactoriamente'});
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <p className={classes.labelTitle}>Evaluar el servicio</p>
        <div className={classes.rating}>
          <Rating
            name="customized-empty"
            value={rate.rating_value}
            precision={0.5}
            size="large"
            onChange={(e, value) => setRate({ ...rate, rating_value: value })}
            emptyIcon={<StarBorderIcon fontSize="inherit" />}
          />
        </div>
        <p className={classes.labelCaption}>Comentarios</p>
        <TextField
          id="comment"
          className={classes.textField}
          multiline
          rowsMax="4"
          margin="normal"
          inputProps={{
            'aria-label': 'bare'
          }}
          value={rate.rating_comment}
          onChange={e => setRate({ ...rate, rating_comment: e.target.value })}
        />
        <div className={classes.actions}>
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={() => {
              submitRate();
            }}
            disabled={!rate.rating_value || resultMessage.isVisible}
          >
            Enviar
          </Button>
        </div>
        {resultMessage.isVisible ? (
          <p className={classes.validationLabel}>{resultMessage.message}</p>
        ) : null}
      </div>
    </div>
  );
};

export default withStyles(styles)(RateService);
